import React from 'react';
import clsx from 'clsx';

import {
    Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {}
}));

export const DateTime = ({ date, time, value, ...props }) => {

    const formatDate = (value) => {
        return (
            <>
                {
                    `${(new Intl.DateTimeFormat("it-IT", {
                        day: "numeric"
                    })).format(value ? Date.parse(value) : new Date())} ${(new Intl.DateTimeFormat("it-IT", {
                        month: "long"
                    })).format(value ? Date.parse(value) : new Date())} ${(new Intl.DateTimeFormat("it-IT", {
                        year: "numeric"
                    })).format(value ? Date.parse(value) : new Date())}`
                }
            </>
        );
    }    
    
    const formaTime = (value) => {
        return (
            <>        
                {(new Intl.DateTimeFormat("it-IT", {
                    hour: "numeric",
                    minute: "numeric",
                    //second: 'numeric'
                })).format(value ? Date.parse(value) : new Date())}
            </>
        );
    }

    return(
        <>
            {date && formatDate(value)}
            &nbsp;
            {time && formaTime(value)}
        </>
    )
}